import { t } from '../i18n';

export const guestServices = [
  {
    label: t('None'),
    value: 'not_specified',
    badgeCls: 'uk-badge-primary',
  },
  {
    label: t('Do Not Disturb'),
    value: 'do_not_disturb',
    badgeCls: 'uk-badge-danger',
  },
  {
    label: t('Clean Requested'),
    value: 'make_up_room',
    badgeCls: 'uk-badge-warning',
  },
];

export const houseKeeping = [
  {
    label: t('Clean'),
    value: 'clean',
    badgeCls: 'uk-badge-success',
  },
  {
    label: t('Dirty'),
    value: 'dirty',
    badgeCls: 'uk-badge-danger',
  },
  {
    label: t('Inspection'),
    value: 'needs_inspection',
    badgeCls: 'uk-badge-warning',
  },
  {
    label: t('Unknown'),
    value: 'unknown',
    badgeCls: 'uk-badge-primary',
  },
];

export const serviceRequests = [
  {
    value: 'new',
    label: t('New'),
    badgeCls: 'uk-badge-danger',
  },
  {
    value: 'acknowledged',
    label: t('Acknowledged'),
    badgeCls: 'uk-badge-warning',
  },
  {
    value: 'assigned',
    label: t('Assigned'),
    badgeCls: 'uk-badge-warning',
  },
  {
    value: 'resolved',
    label: t('Resolved'),
    badgeCls: 'uk-badge-success',
  },
  {
    value: 'closed',
    label: t('Closed'),
    badgeCls: 'uk-badge-primary',
  },
  {
    value: 'canceled',
    label: t('Canceled'),
    badgeCls: 'uk-badge-primary',
  },
];

export const workOrders = [
  {
    value: 'new',
    label: t('New'),
    badgeCls: 'uk-badge-danger',
  },
  {
    value: 'acknowledged',
    label: t('Acknowledged'),
    badgeCls: 'uk-badge-warning',
  },
  {
    value: 'assigned',
    label: t('Assigned'),
    badgeCls: 'uk-badge-warning',
  },
  {
    value: 'in_progress',
    label: t('In Progress'),
    badgeCls: 'uk-badge-primary',
  },
  {
    value: 'closed',
    label: t('Closed'),
    badgeCls: 'uk-badge-primary',
  },
  {
    value: 'canceled',
    label: t('Canceled'),
    badgeCls: 'uk-badge-primary',
  },
];



// WEBPACK FOOTER //
// ./src/config/service-options.js